import { Component, Input, OnInit } from "@angular/core";
import { Evenement } from "apps/idl/src/anakin/models/Evenement";
import { finalize } from "rxjs/operators";
import { ConfirmationSuppressionComponent } from "../../../shared/components/confirmation-suppression/confirmation-suppression.component";
import { DrawerPopoverService } from "../../../shared/services/drawer-popover.service";
import { EvenementService } from "../../../shared/services/evenement.service";
import { EvenementFormComponent } from "../evenement-form/evenement-form.component";

@Component({
	selector: "menu-modifier-evenement",
	templateUrl: "./menu-modifier-evenement.component.html",
	styleUrls: ["./menu-modifier-evenement.component.scss"],
})
export class MenuModifierEvenementComponent implements OnInit {
	@Input() event: Evenement;

	constructor(
		private svcDrawerPopover: DrawerPopoverService,
		private svcEvenement: EvenementService
	) {}


	ngOnInit() {}
	modifEvent(event: Event) {
		const element: HTMLElement = event.currentTarget as HTMLElement;
		const anchorRect: DOMRect = element.getBoundingClientRect();
		this.svcDrawerPopover.open(
			"",
			"60%",
			null,
			EvenementFormComponent,
			{
	      		evenement:this.event,
				onSave: (eventToSave) => {
					this.saveEvent(eventToSave)
				},
				onCancel: () => this.closeMenu(),
			},
			null,
			anchorRect
		);
	}

	public closeMenu(): void {
		this.svcDrawerPopover.close();
	}
	deleteEvent(event: Event) {
		const element: HTMLElement = event.currentTarget as HTMLElement;
		const anchorRect: DOMRect = element.getBoundingClientRect();
		this.svcDrawerPopover.open("Confirmation de suppression", "50%", null,ConfirmationSuppressionComponent, {
		  onConfirm: () => this.handleConfirm(),
		  onCancel: () => this.closeMenu()
		}, null, anchorRect)
	  }
	
	saveEvent = (eventToSave: Evenement): void => {
	
		this.svcEvenement.createOrUpdate(eventToSave).pipe(
			
			finalize(() => {
				this.closeMenu()
			})
		).subscribe();
		
		
	  }
	  handleConfirm () {
		this.svcEvenement.delete(this.event).subscribe((isDeleted: boolean) => {
		 this.closeMenu()
		})
}
}
